import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
export const subscribeEmail = createAsyncThunk(
  'subscription/subscribeEmail',
  async (email, thunkAPI) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/property/email_subscription/`, { email });
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
 